import axios from 'axios';
import { config } from 'config/config';

const branchAxiosaApi = axios.create({
  baseURL: config.BACKEND_API_BASE_URL,
  headers: {
    'x-api-key': config.GATEWAY_API_KEY,
    'Content-Type': 'application/json',
  },
});

export default branchAxiosaApi;
